import store from '@/store'
import { SITE_TYPES } from '@/store/modules/site'

export const session = async () => {
  await Promise.all([
    store.dispatch(SITE_TYPES.actions.loadSiteConfig)
  ])
}

export default session()
